// components/FeaturesAndAmenities.js
import React from 'react';

const FeaturesAndAmenities = ({
    formData,
    amenities,
    features,
    handleAmenityToggle,
    handleFeatureToggle
}) => {
    return (
        <div className="row">
            {/* Amenities */}
            <div className="mb-3 col-12 mt-3">
                <label className="form-label d-block mb-2">Amenities</label>
                <div className="d-flex flex-wrap gap-2">
                    {amenities.map((item) => {
                        const isSelected = formData.amenityIds.includes(item._id);
                        return (
                            <div
                                key={item._id}
                                className={`form-check d-flex align-items-center px-3 py-2 border rounded-pill ${isSelected ? 'bg-primary text-white' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleAmenityToggle(item._id)}
                            >
                                <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    id={`amenity-${item._id}`}
                                    checked={isSelected}
                                    onChange={() => handleAmenityToggle(item._id)}
                                    style={{ display: 'none' }}
                                />
                                <label className="form-check-label m-0" htmlFor={`amenity-${item._id}`}>
                                    {item.name}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Features */}
            <div className="mb-3 col-12 mt-3">
                <label className="form-label d-block mb-2">Features</label>
                <div className="d-flex flex-wrap gap-2">
                    {features.map((item) => {
                        const isSelected = formData.featureIds.includes(item._id);
                        return (
                            <div
                                key={item._id}
                                className={`form-check d-flex align-items-center px-3 py-2 border rounded-pill ${isSelected ? 'bg-success text-white' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleFeatureToggle(item._id)}
                            >
                                <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    id={`feature-${item._id}`}
                                    checked={isSelected}
                                    onChange={() => handleFeatureToggle(item._id)}
                                    style={{ display: 'none' }}
                                />
                                <label className="form-check-label m-0" htmlFor={`feature-${item._id}`}>
                                    {item.name}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FeaturesAndAmenities;
